export const gameNotFoundMsg = 'Active game not found';
